const AuthRoutes = {
    login: "/auth/login",
    logout: "/auth/logout",
    changePassword: "/auth/changepassword",
};

export default AuthRoutes